import { Record } from 'immutable'

// Record
export const PlanSubscriptionRecord = Record(
  {
    id: '',
    createdAt: null,
    createdById: null,
    currentPeriodEnd: null,
    canceledAt: null,
    trialEndAt: null,
  },
  'PlanSubscription'
)
